// extracted by mini-css-extract-plugin
export var table = "corporate-module--table--ZCsQm";
export var subtitle = "corporate-module--subtitle--ZBhT1";
export var subtitleJa = "corporate-module--subtitle--ja--1AzvK";
export var fontJa = "corporate-module--font-ja--Z54b2";